import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/components/common/messageservice';
import { EmpregoNaPistaError } from '../../shared/errors/emprego-na-pista-error';
import { BadInputError } from '../../shared/errors/bad-input-error';
import { WebPage } from '../../shared/web-page';
import { FaseService } from '../../fase/fase.service';

@Component({
  templateUrl: './home.component.html',
})
export class HomeComponent extends WebPage implements OnInit {

  fases;

  constructor(private faseService: FaseService, messageService: MessageService) {
    super(messageService);
  }

  ngOnInit() {
    const mensagem = localStorage.getItem('mensagem');
    if (mensagem != null && mensagem !== '') {
      this.messageService.add({ severity: 'success', summary: 'Sucesso', detail: mensagem });
      localStorage.removeItem('mensagem');
    }

    this.isLoading = true;
    this.faseService.getComInscricoesAbertas()
      .finally(() => this.isLoading = false)
      .subscribe(
        fases => this.fases = fases,
        error => this.gerenciaErro(error)
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/home/home/home.component.ts